const quickLinks = [
  { href: "#penalty", label: "官方处罚追踪" },
  { href: "#takedown", label: "下架事件归档" },
  { href: "#debate", label: "监管争议解析" },
  { href: "#timeline", label: "事件时间线" },
  { href: "#hot", label: "社区热议区" },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto flex w-full flex-col gap-6 px-4 py-8 md:px-6">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-start">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-base" />
              </span>
              <span className="font-label text-[15px] font-bold text-foreground-950">快手黑料</span>
            </a>
            <p className="mt-3 text-[13px] leading-relaxed text-foreground-600">
              一个围绕平台风波、官方处罚、内容下架与监管争议的讨论索引站。我们负责把公告与各方声音收齐，
              你怎么看，评论区见。
            </p>
          </div>

          <nav className="flex flex-col gap-2">
            <span className="font-label text-xs font-bold uppercase tracking-wide text-foreground-500">快速直达</span>
            {quickLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap text-[13px] text-foreground-700 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-2">
            <span className="font-label text-xs font-bold uppercase tracking-wide text-foreground-500">关于本站</span>
            <p className="text-[13px] leading-relaxed text-foreground-600">
              本页为公开信息与讨论的静态整理，不含对任何个体的指控与认定，仅供了解事件全貌与各方说法。
            </p>
            <p className="text-[13px] text-foreground-600">如需联系，可通过页内反馈或客户端入口提交线索。</p>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-4 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <span className="whitespace-nowrap">© 2026 快手黑料 · 信息整理站 · 观点仅代表发言者本人</span>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-shield-check-line text-accent-600" />
            理性吃瓜 · 客观整理 · 欢迎补充线索
          </span>
        </div>
      </div>
    </footer>
  );
}